export enum MaterialsRoutesEnum{
    PREFIX              = 'MATERIALS',
    MATERIALS_LIST      = 'MATERIALS_LIST',
    MATERIALS_DETAIL    = 'MATERIALS_DETAIL',
}